export default {
  leagues: {
    title: "Liga auswählen",
    empty: {
      favoriteLeagues: "Markiere deine Lieblingsligen, damit sie für schnelleren Zugriff oben stehen",
    },
    actions: {
      starFavoriteLeagues: "Lieblingsligen markieren",
    },
    status: {
      live: "Aktiv",
      offseason: "Offseason",
    },
    sections: {
      myLeagues: "Meine Ligen",
      sports: {
        baseball: "Baseball",
        basketball: "Basketball",
        football: "Football",
        "australian-football": "Australian Rules Football",
        rugby: "Rugby",
        hockey: "Hockey",
        soccer: "Fußball",
      },
    },
  },
};
